import { Vent } from "../types";
import { createGenericFormSlice, SliceState } from "./genericFormSlice";

const formSlice = createGenericFormSlice({
  name: "ventConfigTab",
  initialState: {} as SliceState<Vent>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const ventConfigTabReducer = formSlice.reducer;
export default ventConfigTabReducer;
